import script from "./sider.vue?vue&type=script&setup=true&lang=ts"
export * from "./sider.vue?vue&type=script&setup=true&lang=ts"

import "./sider.vue?vue&type=style&index=0&id=1a04f751&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a04f751"]])

export default __exports__